document.addEventListener('click', function (e) {
  const btn = e.target.closest('.card-size-btn');
  if (!btn || btn.classList.contains('card-size-btn--sold-out')) return;

  const picker = btn.closest('.card-size-picker');
  const form = document.getElementById(btn.dataset.formId);
  if (!form) return;

  picker.querySelectorAll('.card-size-btn').forEach(b => b.classList.remove('card-size-btn--active'));
  btn.classList.add('card-size-btn--active');

  const variantInput = form.querySelector('.product-variant-id');
  if (variantInput) variantInput.value = btn.dataset.variantId;

  const addBtn = form.querySelector('.card-size-add-btn');
  if (addBtn) {
    addBtn.style.display = '';
    addBtn.disabled = btn.dataset.available === 'false';
  }
});